import Veil from './Veil';

export default Veil;
